import React, { lazy, useEffect, Suspense } from 'react';
import { Loader, TimeFormatsEnum } from '@wix/calendar-client-library-v3';
import usePrevious from '../../../../hooks/usePrevious';
import {
  getStyleParams,
  isEditorViewMode,
  resizeComponent,
  setHeight,
} from '../../../../utils';

const WeeklyCalendar = lazy(() =>
  import(
    '@wix/calendar-client-library-v3/dist/src/components/containers/WeeklyCalendar/WeeklyCalendar'
  ),
);

// const WeeklyCalendar = lazy(() =>
//   import(
//     '../../localCalendars/components/containers/WeeklyCalendar/WeeklyCalendar'
//   ),
// );

const WeeklyWrapper = ({ calendarsProps }) => {
  const {
    isPreLoaded,
    calendarRef,
    locale,
    isLiveSite,
    wixStyles,
  } = calendarsProps;

  const isEditor = isEditorViewMode();
    const isResponsive =
     wixStyles.numbers.calendarHeightWeekly !== 1
      ? true
      : false;

  useEffect(() => {
    if (isResponsive) {
      setTimeout(() => {
        if (calendarRef?.current) {
          setHeight((calendarRef?.current?.children[1]?.clientHeight)+ 84);
        }
      }, 100);
    }
  }, [isResponsive]);

  const prevProps = usePrevious({ isResponsive });

  useEffect(() => {
    if (prevProps && prevProps.isResponsive !== isResponsive) {
      if (!isResponsive) {
        //FIXME - need to get FCalendat height and setHeight
        setHeight(1071 - 20 - 20); //1071
      }
    }
  }, [isResponsive]);

  useEffect(() => {
    const minHeightResize = () => {
      if (isEditor) {
        const height = window.innerHeight;
        const width = window.innerWidth;
        const minHeight: number = 550;
        const minWidth: number = 550;

        if (isResponsive) {
          if (
            height > calendarRef.current.scrollHeight ||
            calendarRef.current.scrollHeight - height > 50
            // || calendarRef.current.scrollHeight !== height
          ) {
            resizeComponent({
              width,
              height: calendarRef.current.scrollHeight,
            }); // resizeComponent better than setHeight
            // setHeight(calendarRef?.current?.scrollHeight);
            // setHeightByref()
          }
        } else {
          const currentHeight = calendarRef.current.scrollHeight;
          const callendarPadding = 40;
          let daysHeaderHeight = 68.8; // 102
          let controllersHeight = 84; // 144
          daysHeaderHeight = getHeightByIdOrClassName(
            'topPositionDatesWrapper',
            false,
            daysHeaderHeight,
          );
          controllersHeight = getHeightByIdOrClassName(
            'calendarControllersRoot',
            false,
            controllersHeight,
          );
          const fcBoundingHeight = getHeightByIdOrClassName('fc', true, 800);
          const calendarElemsHeight =
            fcBoundingHeight +
            callendarPadding +
            daysHeaderHeight +
            controllersHeight;
          if (window.innerHeight > calendarElemsHeight) {
            resizeComponent({
              width: window.innerWidth,
              height: calendarElemsHeight,
            });
          }
        }

        if (width < minWidth) {
          resizeComponent({ width: minWidth, height });
        }
        if (height < minHeight) {
          resizeComponent({ width, height: minHeight });
        }
      }
    };

    window.addEventListener('resize', minHeightResize, false);
    return () => window.removeEventListener('resize', minHeightResize);
  });

  const timeFormatWeekly =
    getStyleParams()?.numbers?.timeFormatWeekly === 24
      ? TimeFormatsEnum.twentyFourHours
      : TimeFormatsEnum.tweleveHours;

  return (
    <Suspense
      fallback={() => (
        <Loader
          isPreLoaded={isPreLoaded}
          locale={locale}
          isLiveSite={isLiveSite}
        />
      )}
    >
      <WeeklyCalendar
        calendarsProps={{ ...calendarsProps, timeFormat: timeFormatWeekly }}
      />
    </Suspense>
  );
};

export default WeeklyWrapper;

const getHeightByIdOrClassName = (
  artifact: string,
  isClassName: boolean,
  defaultValue: number,
) => {
  let height = defaultValue;
  const ell = isClassName
    ? document.getElementsByClassName(artifact)[0]
    : document.getElementById(artifact);
  const ellBoundingClientRect = ell && ell.getBoundingClientRect();
  height = ellBoundingClientRect?.height || defaultValue;

  return height;
};
